import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'

Vue.use(ElementUI)
// rem适配
function setRem() {
  const html = document.documentElement
  const width = html.clientWidth
  const rem = width / 10
  html.style.fontSize = rem + 'px'
}

setRem()
window.addEventListener('resize', setRem)


new Vue({
  render: h => h(App)
}).$mount('#app')
